import React from 'react';

const Howitworkscard = (props) => {
  return ( 
    <div className={props.cardstyle}>
      <div className='how_it_works_icon_box'>
        <img src={props.cardimg} alt="" />
        <div className='how_it_works_number'>{props.cardnumber}</div>
      </div>
      <div className='how_it_works_card_title'>{props.cardtitle}</div>
      <div className='how_it_works_card_text'>{props.cardtext}</div>
    </div>
   );
}
 
export default Howitworkscard;
